"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createThemeConfigurationEvent = exports.BrandConfigContext = exports.BRAND_CONFIG_UPDATE_EVENT = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

var _extractCssVariables = require("../utils/extractCssVariables");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var BRAND_CONFIG_UPDATE_EVENT = 'brandConfigUpdate';
exports.BRAND_CONFIG_UPDATE_EVENT = BRAND_CONFIG_UPDATE_EVENT;

var createThemeConfigurationEvent = function createThemeConfigurationEvent(data) {
  return new CustomEvent(BRAND_CONFIG_UPDATE_EVENT, {
    detail: {
      data: data
    }
  });
};

exports.createThemeConfigurationEvent = createThemeConfigurationEvent;
var BrandConfigContext = (0, _preactCompat.createContext)({
  config: {}
});
exports.BrandConfigContext = BrandConfigContext;

var BrandConfigProvider = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(BrandConfigProvider, _Component);

  var _super = _createSuper(BrandConfigProvider);

  function BrandConfigProvider() {
    var _this;

    (0, _classCallCheck2.default)(this, BrandConfigProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      config: {}
    });
    return _this;
  }

  (0, _createClass2.default)(BrandConfigProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var cssVariables = document.getElementById('css-variables');
      var styleSheet = cssVariables instanceof HTMLLinkElement || cssVariables instanceof HTMLStyleElement ? cssVariables.sheet : null;
      this.setState({
        config: (0, _extractCssVariables.extractCssVariables)(styleSheet)
      });
      window.addEventListener(BRAND_CONFIG_UPDATE_EVENT, function (event) {
        if (event && 'detail' in event) {
          var newConfig = event.detail.data;

          _this2.setState({
            config: _objectSpread({}, newConfig)
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return (0, _preact.h)(BrandConfigContext.Provider, {
        value: {
          config: this.state.config
        }
      }, children);
    }
  }]);
  return BrandConfigProvider;
}(_preact.Component);

var _default = BrandConfigProvider;
exports.default = _default;